export const UserVerificationKeys = {
    isUserExists: 'isUserExists',
};
